var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    [
      _c("div", { staticClass: "navbar navbar fixed-top px-0" }, [
        _c(
          "div",
          { staticClass: "container relative" },
          [
            _vm.$slots.menu
              ? _c(
                  "button",
                  {
                    staticClass:
                      "d-md-none mr-3 navbar-toggler align-self-center",
                    attrs: {
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": "#navbarSupportedContent",
                      "aria-controls": "navbarSupportedContent",
                      "aria-expanded": "false",
                      "aria-label": "Toggle navigation"
                    }
                  },
                  [_c("span", { staticClass: "navbar-toggler-icon" })]
                )
              : _vm._e(),
            _c(
              "nuxt-link",
              {
                staticClass:
                  "mr-auto p-0 navbar-brand text-uppercase d-inline-flex align-items-center",
                attrs: {
                  to: "/",
                  exact: "",
                  "data-toggle": "collapse",
                  "data-target": "#navbarSupportedContent.show"
                }
              },
              [
                _c("img", {
                  staticClass: "d-inline-block align-center mr-2",
                  attrs: {
                    src: require("assets/img/beta.png"),
                    width: "32",
                    height: "32",
                    alt: "β"
                  }
                }),
                _c("span", { staticClass: "d-none d-sm-inline" }, [
                  _vm._v("\n          Beta\n        ")
                ])
              ]
            ),
            _c("search-form", {
              staticClass: "mr-md-4 order-3 order-md-1",
              attrs: { id: "search-form" }
            }),
            _c(
              "ul",
              {
                staticClass:
                  "order-2 navbar-nav d-flex flex-row align-items-stretch"
              },
              [
                _vm.user
                  ? _c("li", { staticClass: "nav-item dropdown" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          attrs: {
                            href: "#",
                            id: "navbarDropdownMenuLink",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.user.username) +
                              "\n            "
                          ),
                          _c("i", { staticClass: "fa fa-chevron-down" })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu dropdown-menu-right",
                          attrs: { "aria-labelledby": "navbarDropdownMenuLink" }
                        },
                        [
                          _c(
                            "nuxt-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: {
                                to: "/@" + _vm.user.username,
                                exact: "",
                                "data-toggle": "collapse",
                                "data-target": "#navbarSupportedContent.show"
                              }
                            },
                            [_vm._v("\n              Profile\n            ")]
                          ),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _c(
                            "nuxt-link",
                            {
                              staticClass: "dropdown-item",
                              attrs: {
                                "data-toggle": "collapse",
                                "data-target": "#navbarSupportedContent.show",
                                to: "/settings/notification"
                              }
                            },
                            [_vm._v("\n              Settings\n            ")]
                          ),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "/logout" }
                            },
                            [_vm._v("Log out")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                !_vm.user
                  ? _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        { staticClass: "nav-link", attrs: { href: "/login" } },
                        [_vm._v("Log in")]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "navbar-collapse collapse d-md-none scrollable",
            attrs: { id: "navbarSupportedContent" }
          },
          [
            _c(
              "div",
              {
                staticClass: "container",
                style: {
                  "max-height": _vm.collapseHeight
                }
              },
              [_vm._t("menu")],
              2
            )
          ]
        )
      ]),
      _vm._t("jumbotron")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a9bb128", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9bb128","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/Header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1a9bb128","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/Header.vue
// module chunks = 0 15